import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react'
import { useState, memo } from 'react'
import { AiFillPlusCircle, AiOutlineCloseCircle } from 'react-icons/ai'
import { InputDragAndDrop } from './InputDragAndDrop'
import { baseURL } from '../../../../services/api'
import { user } from '../../../../helpers/user'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { renameImageWithDimension } from '../../../../utils/renamedImageSite'

export const ModalRegisterImages = memo(
  ({ openModal, closeModal, isOpen, codProduto }) => {
    const [selectTypeProduct, setSelectTypeProduct] = useState('')

    const onOpen = () => {
      openModal()
    }

    const codUsu = user?.codigo_usuario

    function handleSelectTypeProduct(type) {
      setSelectTypeProduct(type)
    }

    const [imagesInnovation, setImagesInnovation] = useState([])
    const [imagesStore, setImagesStores] = useState([])
    const [loadingUploadImage, setLoadingUploadImage] = useState(false)

    const onClose = () => {
      closeModal()
      setSelectTypeProduct('')
      setImagesInnovation([])
      setImagesStores([])
    }

    const toast = useToast()

    const navigate = useNavigate()

    async function uploadImages() {
      const dataInno = new FormData()
      const dataStore = new FormData()

      if (imagesInnovation.length < 3 || imagesStore.length < 3) {
        toast({
          title: 'Erro ao enviar imagens',
          description: 'Selecione pelo menos 3 imagens para cada site',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        })
        return
      }

      imagesInnovation.forEach((image) => {
        dataInno.append('imagem[]', image)
      })
      dataInno.append('codigo_produto', codProduto)
      dataInno.append('codigo_usuario', codUsu)
      dataStore.append('codigo_produto', codProduto)
      dataStore.append('codigo_usuario', codUsu)

      imagesStore.forEach((image) => {
        dataStore.append('imagem[]', image)
      })

      setLoadingUploadImage(true)

      const [uploadInno, uploadStore] = await Promise.all([
        baseURL.post('/fluxo-imagem/upload-imagens-produtos-s3', dataInno),
        baseURL.post(
          '/fluxo-imagem/upload-imagens-produtos-s3-store',
          dataStore
        ),
      ])

      if (uploadInno.status === 200 && uploadStore.status === 200) {
        toast({
          title: 'Imagens enviadas com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        })
        onClose()
        setLoadingUploadImage(false)
        navigate('/financeiro/cadastro-produto')
      }

      console.log(uploadInno, uploadStore)

      setLoadingUploadImage(false)
    }

    return (
      <>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent maxW="1024px" w="full">
            <ModalHeader
              bg="#CFCFCF"
              py="7px"
              mx="52px"
              my="10px"
              textAlign="center"
              textTransform="uppercase"
            >
              Upload de Imagens
            </ModalHeader>
            <ModalBody>
              <Text
                as="h3"
                maxW="490px"
                fontSize="14px"
                fontWeight="semibold"
                textAlign="center"
                mx="auto"
              >
                SELECIONE ABAIXO O TIPO DE PRODUTO QUE VOCÊ VAI CADASTRAR:
                Brinde personalizado ou Impresso360
              </Text>

              <Flex gap="94px" justifyContent="center" mt="1.5rem">
                {selectTypeProduct === 'brinde' && (
                  <>
                    <InputDragAndDrop
                      label="Innovation Brindes"
                      setImages={setImagesInnovation}
                      images={imagesInnovation}
                    />
                    <InputDragAndDrop
                      label="Innovation Store"
                      setImages={setImagesStores}
                      images={imagesStore}
                    />
                  </>
                )}
                {selectTypeProduct === '' && (
                  <>
                    <Box
                      maxW="320px"
                      w="full"
                      minH="253px"
                      rounded="md"
                      boxShadow="8px 16px 32px #0000001A"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                      fontSize="20px"
                      fontWeight="semibold"
                      cursor="pointer"
                      gap="29px"
                      onClick={() => handleSelectTypeProduct('brinde')}
                    >
                      Brinde personalizado
                      <Icon
                        as={AiFillPlusCircle}
                        w="49px"
                        h="49px"
                        color="#378BBF"
                      />
                    </Box>
                    <Box
                      maxW="320px"
                      w="full"
                      minH="253px"
                      rounded="md"
                      boxShadow="8px 16px 32px #0000001A"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                      fontSize="20px"
                      fontWeight="semibold"
                      cursor="pointer"
                      gap="29px"
                      onClick={() => handleSelectTypeProduct('impresso')}
                    >
                      Impresso 360
                      <Icon
                        as={AiFillPlusCircle}
                        w="49px"
                        h="49px"
                        color="#A0BF37"
                      />
                    </Box>
                  </>
                )}
              </Flex>
            </ModalBody>

            <ModalFooter
              maxW="740px"
              w="full"
              mx="auto"
              px={0}
              position="relative"
            >
              <Button
                mr="auto"
                onClick={onClose}
                border={0}
                bg="transparent"
                fontSize="20px"
              >
                <Icon as={AiOutlineCloseCircle} w="20px" h="20px" mr=".5rem" />
                Cancelar
              </Button>
              <Button
                position="absolute"
                top="50%"
                right="50%"
                transform="translate(50%, -50%)"
                colorScheme="blue"
                maxW="295px"
                w="full"
                rounded={'full'}
                onClick={uploadImages}
                isLoading={loadingUploadImage}
              >
                Confirmar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
)
